import { motion } from "framer-motion";

const EASE = [0.33, 1, 0.68, 1];

// Line-by-line masked reveal. Animates via parent (untransformed) so
// IntersectionObserver reads a stable bounding box — children reveal on stagger.
export function MaskReveal({ lines, className = "", delay = 0, as = "h2" }) {
  const Tag = motion[as] || motion.h2;
  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.09, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "110%" },
    visible: { y: 0, transition: { duration: 1, ease: EASE } },
  };
  return (
    <Tag className={className} variants={container} initial="hidden"
      whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span style={{ display: "block" }} variants={child}>{line}</motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}
